import React from 'react'
import RestaurantForm from '../../components/RestaurantForm/RestaurantForm'
import withLayout from '../../Layouts/AdminPanel'

function Settings() {
	return <RestaurantForm />
}

export default withLayout(Settings)
